import React, { useState, useRef } from 'react';
import { useTranslation } from "react-i18next";

import FormatUrl from "../../utils/UrlFormatter";
import StandardModal from '../Modals/standardModal';
import './staffManage.css';
import { specializationOptions } from './specializationConstants';  // Import the constants

// Function to fetch data from the NPI Registry API
const fetchNpiData = async (npiNumber) => {
  try {
    const response = await fetch(`https://npiregistry.cms.hhs.gov/api/?number=${npiNumber}&version=2.1`);
    const data = await response.json();
    return data.results && data.results.length > 0 ? { verified: true, data: data.results[0] } : { verified: false };
  } catch (error) {
    console.error("Error fetching NPI data:", error);
    return { verified: false };
  }
};

const AddPractitioner = ({ onAddPractitioner, existingPractitioners, clinicId ,onSuccess, pracLimit }) => {
  const { t } = useTranslation(); 

  const [firstName, setFirstName] = useState('');
  const [middleName, setMiddleName] = useState('');
  const [lastName, setLastName] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [gender, setGender] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [dateOfBirth, setDateOfBirth] = useState('')
  const [discipline, setDiscipline] = useState('Physiotherapy');
  // licenseNumber is coming as Prop from Staff view
  const [licenseNumber, setLicenseNumber] = useState('');
  const [licenseExpiry, setLicenseExpiry] = useState('');
  const [specialization, setSpecialization] = useState('');
  const [yearsOfExperience, setYearsOfExperience] = useState('');
  // const [verificationStatus, setVerificationStatus] = useState('Pending');
  /* eslint-disable no-unused-vars */
  const [licenseFile, setLicenseFile] = useState(null); 
  const [errors, setErrors] = useState({});
  const [licenseVerified, setLicenseVerified] = useState(null);
  const [isVerifying, setIsVerifying] = useState(false);
  const [region, setRegion] = useState('Canada');
  const [degreeInput, setDegreeInput] = useState('');
  const [selectedDegrees, setSelectedDegrees] = useState([]);
  const [skillInput, setSkillInput] = useState('');
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [isRegistered, setIsRegistered] = useState(false);
  const [appointmentFee, setAppointmentFee] = useState('');

  // const [showBanner, setShowBanner] = useState(false);
  const [modalTitle, setModalTitle] = useState('');  
  const [isModalVisible, setIsModalVisible] = useState(false);  
  const [modalMessage, setModalMessage] = useState('');  

  const fileInputRef = useRef(null);  

  const closeModal = () => {
    setIsModalVisible(false);
    setModalMessage('');  
    if (modalTitle === 'Success') {  
      onSuccess();  
  }
  };


  const resetFormFields = () => {
    setFirstName('');
    setMiddleName('');
    setLastName('');
    setDisplayName('');
    setGender('');
    setEmail('');
    setPhone('');
    setDiscipline('Physiotherapy');
    setLicenseNumber('');
    setLicenseExpiry('');
    setDateOfBirth('');
    setSpecialization('');
    setYearsOfExperience('');
    setLicenseVerified(null);
    // setVerificationStatus('Pending');
    setErrors({});
    setDegreeInput('');  
    setSelectedDegrees([]);  
    setSkillInput('');
    setSelectedSkills([]);
    
    if (fileInputRef.current) {
      fileInputRef.current.value = null;  
    }
  };

  const addDegree = () => {
    if (degreeInput.trim() && !selectedDegrees.includes(degreeInput.trim())) {
      setSelectedDegrees([...selectedDegrees, degreeInput.trim()]); // Add degree
      setDegreeInput(''); // Clear input field after adding
    }
  };
  
  const removeDegree = (degree) => {
    setSelectedDegrees(selectedDegrees.filter((d) => d !== degree)); // Remove degree
  };
  
  const addSkill = () => {
    if (skillInput.trim() && !selectedSkills.includes(skillInput.trim())) {
      setSelectedSkills([...selectedSkills, skillInput.trim()]);
      setSkillInput('');
    }
  };
  
  const removeSkill = (skill) => {
    setSelectedSkills(selectedSkills.filter((s) => s !== skill));
  };

  
  const validate = () => {
      let valid = true;
      const newErrors = {};

      // const today = new Date();
      // const selectedDate = new Date(dateOfBirth);

      if (!firstName.trim()) {
        newErrors.firstName = t("staff-add-validation.first_name_required");
        valid = false;
      }
      if (!lastName.trim()) {
        newErrors.lastName = t("staff-add-validation.last_name_required");
        valid = false;
      }
      if (!email.trim() || !/\S+@\S+\.\S+/.test(email)) {
        newErrors.email = t("staff-add-validation.valid_email_required");
        valid = false;
      }
      if (!phone.trim() || !/^\d{10}$/.test(phone)) {
        newErrors.phone = t("staff-add-validation.valid_phone_required");
        valid = false;
      }
         //  License Number & Expiry Required Only for Registered Practitioners
    if (isRegistered) {
      if (!licenseNumber.trim()) {
          newErrors.licenseNumber = t("staff-add-validation.license_number_required");
          valid = false;
      }
      // if (!licenseExpiry.trim() || new Date(licenseExpiry) < new Date()) {
      //     newErrors.licenseExpiry = t("staff-add-validation.license_expiry_required");
      //     valid = false;
      // }

      // Validate Region if Registered
      if (!region.trim()) {
          newErrors.region = t("staff-add-validation.region_required");
          valid = false;
      }
  }

      // if (!dateOfBirth.trim()) {
      //   newErrors.dateOfBirth = t("staff-add-validation.dob_required");
      //   valid = false;
      // } else if (selectedDate >= today) {
      //   newErrors.dateOfBirth = t("staff-add-validation.dob_future_error");
      //   valid = false;
      // } else {
      //   // Calculate Age
      //   const birthYear = selectedDate.getFullYear();
      //   const currentYear = today.getFullYear();
      //   let age = currentYear - birthYear;
      
      //   // Adjust for cases where birthday hasn’t occurred yet this year
      //   const birthMonth = selectedDate.getMonth();
      //   const birthDay = selectedDate.getDate();
      //   if (today.getMonth() < birthMonth || (today.getMonth() === birthMonth && today.getDate() < birthDay)) {
      //     age--;
      //   }
      
      //   // Ensure user is at least 18 years old
      //   if (age < 18) {
      //     newErrors.dateOfBirth = t("staff-add-validation.dob_age_error");
      //     valid = false;
      //   }
      
      //   // Ensure `yearsOfExperience` is less than `age`
      //   if (!isNaN(yearsOfExperience) && parseInt(yearsOfExperience) >= age) {
      //     newErrors.yearsOfExperience = t("staff-add-validation.experience_age_error");
      //     valid = false;
      //   }
      // }
      
      // if (!specialization.trim()) {
      //   newErrors.specialization = t("staff-add-validation.specialization_required");
      //   valid = false;
      // }
      
      // if (isRegistered && region === 'Canada' && !fileInputRef.current.files.length) {
      //   newErrors.licenseFile = t("staff-add-validation.license_file_required");
      //   valid = false;
      // }

      if (!appointmentFee.trim()) {
        newErrors.appointmentFee = t("staff_add.appointment_fee_required");
        valid = false;
      } else if (isNaN(appointmentFee) || Number(appointmentFee) < 0) {
        newErrors.appointmentFee = t("staff_add.appointment_fee_invalid");
        valid = false;
      } else if (!/^\d+(\.\d{1,2})?$/.test(appointmentFee)) {
        newErrors.appointmentFee = t("staff_add.appointment_fee_invalid");
        valid = false;
      }
      
      if (selectedSkills.length === 0) {
        newErrors.skills = t("staff_add.skills_required");
        valid = false;
      }
      
      setErrors(newErrors);
      return valid;
  };


  const verifyLicense = async () => {
    setIsVerifying(true);
    const response = await fetchNpiData(licenseNumber);
    setIsVerifying(false);
    setLicenseVerified(response.verified);
  };

  const handleFileUpload = (e) => {
    setLicenseFile(e.target.files[0]);  // Store the uploaded file in the licenseFile state
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check for duplicate license number
    if (isRegistered) {
      const isLicenseNumberDuplicate = Array.isArray(existingPractitioners) &&
        existingPractitioners.some(
          (practitioner) => practitioner.licenseNumber === licenseNumber
        );
    
      if (isLicenseNumberDuplicate) {
        setModalTitle(t("staff_add.modal_duplicate_license"));  
        setModalMessage(t("staff_add.modal_duplicate_message"));
        setIsModalVisible(true);
        return;
      }
    }
    

    if (!validate() || (licenseVerified !== true && region === 'USA')) return;

    try {
        // Fetch CSRF token
        const csrfUrl = FormatUrl(`/csrf-token/`);
        const csrfResponse = await fetch(csrfUrl, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
        });

        if (!csrfResponse.ok) throw new Error('Failed to fetch CSRF token');

        const csrfData = await csrfResponse.json();
        const csrfToken = csrfData.csrfToken;

        // Prepare FormData for backend integration
        const formData = new URLSearchParams();  // Changed to URLSearchParams for application/x-www-form-urlencoded
        formData.append('firstName', firstName);
        formData.append('middleName', middleName);
        formData.append('lastName', lastName);
        if (displayName) {
          formData.append('displayName', displayName);
        }
        if (gender) {
          formData.append('gender', gender);
        }        
        formData.append('email', email);
        // formData.append('phone', phone);
        formData.append('phone', `+1${phone}`);
        formData.append('discipline', discipline);
        formData.append('licenseNumber', licenseNumber);
        formData.append('licenseExpiry', licenseExpiry);
        formData.append('dateOfBirth', dateOfBirth);
        formData.append('specialization', specialization);
        formData.append('yearsOfExperience', yearsOfExperience);
        // formData.append('verificationStatus', verificationStatus);
        formData.append('region', region);
        formData.append('clinic_id', clinicId);  
        formData.append('degrees', selectedDegrees.join(','));
        formData.append('skills', selectedSkills.join(','));
        formData.append('is_registered', isRegistered ? 'true' : 'false');
        formData.append('appointment_fee', parseFloat(appointmentFee).toFixed(2));

        const apiUrl = FormatUrl('/add-doctor/');
        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-CSRFToken': csrfToken,
            },
            body: formData,
            credentials: 'include',  // Includes session cookie
        });

        // if (!response.ok) {
        //     throw new Error('Failed to add practitioner');
        // }

        const result = await response.json();

        const backendError = result?.error;
        const isSpecificError =
          backendError === "Maximum practioners for your account exceeded." ||
          backendError === "Payments is not setup, you cannot add a practitioner.";

        if (isSpecificError) {
          setModalTitle(t("staff_add.modal_error"));
          setModalMessage(backendError); // Show plain text
          setIsModalVisible(true);
          return;
        }

        // For everything else, rely on generic error handling
        if (!response.ok || result.status !== "Success") {
          throw new Error('Failed to add practitioner');
        }

        // Show success message and reset form fields
        setModalTitle(t("staff_add.modal_success"));  
        setModalMessage(t("staff_add.modal_success_message"));
        setIsModalVisible(true);

        resetFormFields();
    } catch (error) {
        console.error("Error during practitioner addition:", error);
        setModalTitle(t("staff_add.modal_error"));  
        setModalMessage(t("staff_add.modal_error_message"));
        setIsModalVisible(true);
    }
};

  return (
    <>
    <form onSubmit={handleSubmit}>
      <h3 className="add-practitioner-title">{t("staff_add.title")}</h3>

      {/* Success banner */}
      {/* {showBanner && <div className="success-banner">Practitioner successfully added!</div>} */}
      {/* Mandatory Fields Banner */}
      <div className="mandatory-fields-banner">
          <p>{t("staff_add.note_one")} <span className="mandatory">*</span> {t("staff_add.note_one")}.</p>
      </div>

      <div className="name-fields">
        <input type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} placeholder={t("staff_add.first_name")} required />
        {errors.firstName && <p className="error">{errors.firstName}</p>}
        <input type="text" value={middleName} onChange={(e) => setMiddleName(e.target.value)} placeholder={t("staff_add.middle_name")} />
        <input type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} placeholder={t("staff_add.last_name")} required />
        {errors.lastName && <p className="error">{errors.lastName}</p>}
        <input
          type="text"
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
          placeholder={`${t("staff_add.display_name")} (${t("staff_add.optional")})`}
        />
      </div>

      <div className="label-input-container">
        {/* <label htmlFor="gender">{t("staff_add.gender")}</label> */}
        <select
          id="gender"
          value={gender}
          onChange={(e) => setGender(e.target.value)}
        >
          <option value="">{t("staff_add.select_gender")}</option>
          <option value="M">{t("staff_add.gender_male")}</option>
          <option value="F">{t("staff_add.gender_female")}</option>
          {/* <option value="Non-Binary">{t("staff_add.gender_non_binary")}</option>
          <option value="Prefer not to say">{t("staff_add.gender_prefer_not")}</option> */}
        </select>
      </div>

      <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t("staff_add.prac_email")} required />
      {errors.email && <p className="error">{errors.email}</p>}

      {/* <input type="text" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder={t("staff_add.prac_phone")} required /> */}
      <div className="label-input-container phone-fix-override">
        <label htmlFor="phone">
          {t("staff_add.prac_phone")}
        </label>
        <div className="phone-input-split-add">
          <span className="phone-prefix-add">+1</span>
          <input
            id="phone"
            type="text"
            value={phone}
            maxLength={10}
            onChange={(e) => {
              const numeric = e.target.value.replace(/\D/g, '');
              setPhone(numeric);
            }}
            placeholder="1234567890"
            required
          />
        </div>
        {errors.phone && <p className="error">{errors.phone}</p>}
      </div>

      <div className="label-input-container">
        <label htmlFor="dateOfBirth">{t("staff_add.dob")}</label>
        <input type="date" id="dateOfBirth" value={dateOfBirth} onChange={(e) => setDateOfBirth(e.target.value)} />
        {/* {errors.dateOfBirth && <p className="error">{errors.dateOfBirth}</p>} */}
      </div>
      
      <input
        type="text"
        value={appointmentFee}
        onChange={(e) => setAppointmentFee(e.target.value)}
        placeholder={t("staff_add.appointment_fee_placeholder")}
      />
      {errors.appointmentFee && <p className="error">{errors.appointmentFee}</p>}

      <div className="degree-input-container">
        <label htmlFor="degrees" className="degree-label">{t("staff_add.qualifications")}</label>
        
        <div className="degree-input-wrapper">
          <div className="degrees-list">
            {selectedDegrees.map((degree, index) => (
              <span key={index} className="degree-tag">
                {degree}
                <button type="button" className="remove-degree-btn" onClick={() => removeDegree(degree)}>×</button>
              </span>
            ))}
          </div>

          <div className="degree-input-section">
            <input
              type="text"
              value={degreeInput}
              // onChange={(e) => setDegreeInput(e.target.value)}
              onChange={(e) => {
                const value = e.target.value;
                if (/^[a-zA-Z\s]*$/.test(value)) { //Allow only letters and spaces
                  setDegreeInput(value);
                }
              }}
              placeholder={t("staff_add.enter_degree")}
              className="degree-input"
            />
            
            <button type="button" className="add-degree-btn" onClick={addDegree}>
            {t("staff_add.add")}
            </button>
          </div>
        </div>
      </div>
      
      <div className="degree-input-container">
        <label htmlFor="skills" className="degree-label">
          {t("staff_add.skills")}
        </label>

        <div className="degree-input-wrapper">
          <div className="degrees-list">
            {selectedSkills.map((skill, index) => (
              <span key={index} className="degree-tag">
                {skill}
                <button type="button" className="remove-degree-btn" onClick={() => removeSkill(skill)}>×</button>
              </span>
            ))}
          </div>

          <div className="degree-input-section">
            <input
              type="text"
              value={skillInput}
              onChange={(e) => {
                const value = e.target.value;
                if (/^[a-zA-Z\s]*$/.test(value)) {
                  setSkillInput(value);
                }
              }}
              placeholder={t("staff_add.enter_skill")}
              className="degree-input"
            />

            <button type="button" className="add-degree-btn" onClick={addSkill}>
              {t("staff_add.add")}
            </button>
          </div>
        </div>

        {errors.skills && <p className="error">{errors.skills}</p>}
      </div>


      <div className="staff-add-registration-radio-group">
        <label className="staff-add-radio-title">{t("staff_add.registration_status")}</label>
        <div className="staff-add-radio-options">
            <label className="staff-add-radio-label">
                <input
                    type="radio"
                    name="registrationStatus"
                    value="registered"
                    checked={isRegistered}
                    onChange={() => setIsRegistered(true)}
                />
                {t("staff_add.registered")}
            </label>

            <label className="staff-add-radio-label">
                <input
                    type="radio"
                    name="registrationStatus"
                    value="not_registered"
                    checked={!isRegistered}
                    onChange={() => {
                        setIsRegistered(false);
                        setLicenseNumber(""); 
                    }}
                />
                {t("staff_add.not_registered")}
            </label>
        </div>
    </div>

      <div className="dropdown-container">
        {/* Discipline Drop-Down */}
        <select value={discipline} onChange={(e) => {
          setDiscipline(e.target.value);
          setSpecialization('');  
        }}>
          <option value="Physiotherapy">{t("disciplines.Physiotherapy")}</option>
          <option value="Massage Therapy">{t("disciplines.Massage_Therapy")}</option>
          <option value="Acupuncture">{t("disciplines.Acupuncture")}</option>
          {/* <option value="Chiropractic">{t("disciplines.Chiropractic")}</option> */}
          {/* <option value="Orthopaedics">{t("disciplines.Orthopaedics")}</option> */}
          {/* <option value="Certified Reflexologist">{t("disciplines.Certified_Reflexologist")}</option> */}
          {/* <option value="Accupuncture">{t("disciplines.Accupuncture")}</option>
          <option value="Osteopath">{t("disciplines.Osteopath")}</option> */}
        </select>

        {/* Specialization Drop-Down (Dynamically populated) */}
        <select value={specialization} onChange={(e) => setSpecialization(e.target.value)}>
          <option value="" disabled>{t("staff_add.specialization")}</option>
          {specializationOptions[discipline]?.map((spec, index) => (
            <option key={index} value={spec}>{t(`specializations.${spec}`)}</option>
          ))}
        </select>
        {/* {errors.specialization && <p className="error">{errors.specialization}</p>} */}
      </div>

      <div className="input-container">
        <input
          type="number"
          id="experience"
          value={yearsOfExperience}
          onChange={(e) => setYearsOfExperience(e.target.value)}
          placeholder={t("staff_add.experience")}
          min="0"
        />
        {/* {errors.yearsOfExperience && <p className="error">{errors.yearsOfExperience}</p>} */}


        <input
        type="text"
        id="licenseNumber"
        value={licenseNumber}
        onChange={(e) => setLicenseNumber(e.target.value)}
        placeholder={t("staff_add.license")}
        required={isRegistered}
        disabled={!isRegistered}
        className={`staff-add-license-input ${isRegistered ? 'enabled' : 'disabled'}`}
    />
    
    {!isRegistered && (
        <p className="staff-add-helper-text">{t("staff_add.license_disabled_hint")}</p>
    )}
    {errors.licenseNumber && <p className="error">{errors.licenseNumber}</p>}
      </div>

      {/* License Expiry Input - Show Only if Registered */}
      {isRegistered && (
          <div className="label-input-container">
              <label htmlFor="licenseExpiry">{t("staff_add.expiry")}</label>
              <input
                  type="date"
                  id="licenseExpiry"
                  value={licenseExpiry}
                  onChange={(e) => setLicenseExpiry(e.target.value)}
                  className="staff-add-license-expiry"
              />
              {/* {errors.licenseExpiry && <p className="error">{errors.licenseExpiry}</p>} */}
          </div>
      )}

      {/* Region Dropdown - Only Shown for Registered Practitioners */}
      {isRegistered && (
          <div className="label-input-container">
              {/* <label>{t("staff_add.region")}</label> */}
              <select
                  value={region}
                  onChange={(e) => setRegion(e.target.value)}
                  className="staff-add-region-dropdown"
              >
                  <option value="Canada">{t("staff_add.manual_verification")}</option>
                  {/* <option value="USA">USA (NPI Verification)</option> */}
              </select>
          </div>
      )}

      {/* License Verification (USA) - Only if Region is USA */}
      {isRegistered && region === 'USA' && (
          <>
              <button type="button" onClick={verifyLicense} disabled={isVerifying}>
                  {isVerifying ? 'Verifying...' : 'Verify License'}
              </button>
              {licenseVerified === true && <p className="success">License verified</p>}
              {licenseVerified === false && <p className="error">License not valid</p>}
          </>
      )}

      {/* File Upload for Manual License Verification (Canada) - Only if Registered */}
      {isRegistered && region === 'Canada' && (
          <>
              <input ref={fileInputRef} type="file" accept="application/pdf,image/*" onChange={handleFileUpload} />
              {errors.licenseFile && <p className="error">{errors.licenseFile}</p>}
          </>
      )}

          {/* Admin updates verification status manually for Canadian licenses */}
          {/* {region === 'Canada' && (
            <select value={verificationStatus} onChange={(e) => setVerificationStatus(e.target.value)}>
              <option value="Pending">Pending Verification</option>
              <option value="Verified">Verified</option>
              <option value="Rejected">Rejected</option>
            </select>
          )} */}

      {/* Submit button - disabled if license not verified for USA practitioners */}
      <div className="button-container">
          <button type="submit" className="add-practitioner-btn" disabled={region === 'USA' && licenseVerified !== true}>
          {t("staff_add.add_prac")}
          </button>
          <button type="button" className="cancel-practitioner-btn" onClick={resetFormFields}>
          {t("staff_add.cancel")}
          </button>
      </div>
    </form>

    {/* Modal to show duplicate license number */}
    <StandardModal
    isOpen={isModalVisible}
    onClose={closeModal}
    title={modalTitle}
    message={modalMessage}
  />
  </>
  );
};

export default AddPractitioner;
